import { CustomButton } from '@buttons/CustomButton';
import { ModalHelp } from '@modals/ModalHelp';
import { ModalContact } from '@modals/ModalNeedHelp/ModalContact';
import {
  Box,
  Fade,
  Link,
  Menu,
  Theme,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { ZustandContext } from '@store/modalStore';
import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import PhoneIcon from '@mui/icons-material/PhoneOutlined';
import LogoPrimary from '@assets/images/logo-primary.png';
import { makeStyles } from '@mui/styles';
import { useButtonNeedHelpVisibleStore } from '@store/buttonNeedHelpVisisble';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
  },
  logo: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'space-around',
  },
  spacer: {
    marginLeft: theme.spacing(2),
  },
  menu: {
    padding: 0,
  },
  popOverPaper: {
    width: '100%',
    marginTop: 40,
  },
}));

export function DesktopNavbar() {
  const { show, hide } = React.useContext(ZustandContext);
  const { push } = useHistory();
  const { breakpoints, palette } = useTheme();
  const { visibleButton } = useButtonNeedHelpVisibleStore();
  const isDesktop = useMediaQuery(breakpoints.up('lg'));
  const isMobile = useMediaQuery(breakpoints.down('sm'));
  const isTablet = useMediaQuery(breakpoints.down('md'));
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const classes = useStyles();
  const { pathname } = useLocation();

  const open = Boolean(anchorEl);
  const handleClose = () => setAnchorEl(null);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const isCurrentHome = (): boolean => {
    if (pathname === '/') {
      return false;
    } else if (pathname === '/home-alt') {
      return false;
    } else if (pathname === '/quotation') {
      return false;
    }
    return true;
  };

  return (
    <div className={classes.logo}>
      <Box
        component={'img'}
        src={LogoPrimary}
        sx={{
          maxWidth: { xs: 120, md: 120 },
        }}
        style={{
          objectFit: 'contain',
          cursor: 'pointer',
        }}
        alt={'Inter, seguro, seguro'}
        onClick={() => push('/')}
      />
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i}>
          <CustomButton
            text={
              i === 0
                ? 'Seguros'
                : i === 1
                ? 'Moto Segura'
                : i === 2
                ? 'Quienes Somos'
                : i === 3
                ? 'Blog'
                : i === 4
                ? 'Promociones'
                : ''
            }
            //@ts-ignore
            onClick={(e) => {
              if (i === 0) {
                handleClick(e);
              }
              if (i === 1) {
                window.open("https://inter-motosegura-qa.web.app/")
              }
              if (i === 2) {
                window.open('https://inter.mx/about-us', '_blank');
              }
              if (i === 3) {
                window.open('https://inter.mx/blog', '_blank');
              }
              if (i === 4) {
                window.open('https://inter.mx/promotions', '_blank');
              }
            }}
            size={'medium'}
            style={{
              color: palette.text.primary,
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '16px',
            }}
            color={'inherit'}
            variant={'text'}
          />
        </div>
      ))}
      <Menu
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            padding: '10px 15px',
          }}
        >
          <Link
            target="_blank"
            href="https://medicoseguro.inter.mx/inicio"
            style={{
              textDecoration: 'none',
              padding: '5px',
              color: 'black',
            }}
          >
            Médico Seguro
          </Link>
          <Link
            target="_blank"
            href="https://mascotasegura.inter.mx/seguro-mascota/landing"
            style={{
              textDecoration: 'none',
              padding: '5px',
              color: 'black',
            }}
          >
            Mascota Segura
          </Link>
          <Link
            target="_blank"
            href="https://productos.inter.mx/bien-seguro"
            style={{
              textDecoration: 'none',
              padding: '5px',
              color: 'black',
            }}
          >
            Bien Seguro
          </Link>
          <Link
            target="_blank"
            href="https://inter.mx/viaje-seguro"
            style={{
              textDecoration: 'none',
              padding: '5px',
              color: 'black',
            }}
          >
            Viaja Seguro
          </Link>
        </Box>
      </Menu>
      {isCurrentHome()
        ? visibleButton && (
            <CustomButton
              text={'¿Necesitas ayuda?'}
              onClick={() => {
                if (pathname === '/' || pathname === '/options') {
                  show(ModalHelp, { onClose: hide });
                  return;
                }
                show(ModalContact, { onClose: hide });
              }}
              size={'medium'}
              variant={'contained'}
              color={'primary'}
              startIcon={<PhoneIcon />}
              style={{
                textTransform: 'capitalize',
                fontWeight: 600,
                fontSize: '13px',
                padding: ' 13px 18.5px',
              }}
            />
          )
        : //Boton de ayuda !home
          visibleButton && (
            <CustomButton
              text={'¿Necesitas ayuda?'}
              onClick={() => {
                if (pathname === '/') {
                  show(ModalHelp, { onClose: hide });
                  return;
                }
                show(ModalContact, { onClose: hide });
              }}
              size={'medium'}
              variant={'contained'}
              startIcon={<PhoneIcon />}
              style={{
                color: palette.common.white,
                backgroundColor: palette.primary.main,
                fontSize: '13px',
                textTransform: 'none',
                fontWeight: 'normal',
              }}
            />
          )}
    </div>
  );
}
